export async function getAppointments() {
  const response = await fetch("https://yhc75qpqp6.execute-api.us-east-2.amazonaws.com/prod/appointments");
  
  if (!response.ok) {
      throw new Error("Network response was not ok");
  }
  
  const data = await response.json();
  return data;
}
